import React from "react";
import i18n from "i18next";
import { LuScanLine } from "react-icons/lu";
import { IMAGE_EDIT_FEATURES } from "./ImageAnimatorModal";
import "../timeline/IdeaTimeline/components/AnimationPanel/index.scss";

// A single feature card (thumb + name). Shared by the normal features and the
// extra "Alan İşlemleri" entry.
function FeatureCard({ Icon, name, disabled, comingSoon, hint, onClick }) {
  return (
    <div
      className="ap-card"
      aria-disabled={disabled}
      title={hint || ""}
      onClick={disabled ? undefined : onClick}
      style={{
        width: "100%",
        minWidth: 0,
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? "default" : "pointer",
        position: "relative",
      }}
    >
      <div className="ap-card-thumb">
        <span className="ap-card-demo">
          <Icon size={20} />
        </span>
      </div>
      <span
        className="ap-card-name"
        style={{
          whiteSpace: "normal",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          width: "100%",
          minHeight: "2.6em",
        }}
      >
        {name}
      </span>
      {comingSoon ? (
        <span
          style={{
            fontSize: 10,
            fontWeight: 600,
            color: "#6b7280",
            textTransform: "uppercase",
            letterSpacing: 0.4,
          }}
        >
          {i18n.t("MerlinComingSoon")}
        </span>
      ) : null}
    </div>
  );
}

export default function MerlinFeaturesPanel({
  onSelectFeature,
  onSelectAreaOp,
  features = IMAGE_EDIT_FEATURES,
}) {
  const cards = features.map((feature) => {
    const comingSoon = !!feature.comingSoon;
    // `disabled` (with an optional `disabledHint` tooltip) blocks a feature
    // that isn't usable yet in this context. Rendered dimmed, no click.
    const disabled = comingSoon || !!feature.disabled;
    return (
      <FeatureCard
        key={feature.id}
        Icon={feature.icon}
        name={i18n.t(feature.name)}
        disabled={disabled}
        comingSoon={comingSoon}
        hint={feature.disabled ? feature.disabledHint || "" : ""}
        onClick={() => onSelectFeature(feature.id)}
      />
    );
  });

  // "Görseli Düzenle" (the area-ops modal, which now also holds the whole-image
  // edits) leads the grid. Only when the host wired it (editor canvas).
  if (typeof onSelectAreaOp === "function") {
    cards.unshift(
      <FeatureCard
        key="area-ops"
        Icon={LuScanLine}
        name={i18n.t("AreaOps.Title")}
        onClick={() => onSelectAreaOp()}
      />
    );
  }

  return (
    <div className="ap-panel" style={{ height: "auto", overflow: "visible" }}>
      <div
        className="ap-grid"
        style={{
          paddingTop: 12,
          paddingLeft: 10,
          paddingRight: 10,
          overflowY: "visible",
          flex: "none",
          alignItems: "start",
        }}
      >
        {cards}
      </div>
    </div>
  );
}
